export default {
  system: {
    user: '用户',
    level: '等级',
    earnPerTap: '每次点击收益',
    coinsToLevelUp: '升级所需金币',
    profitPerHour: '每小时收益',
    coming1: '有趣的内容',
    coming2: '即将在这里呈现....',
    close: '关闭',
    friends: '好友',
    continue: '继续',
  },
  settings: {
    chooseNetwork: '选择网络',
    chooseLanguage: '选择语言',
  },
  popup_CheckTask: {
    join: '加入',
    check: '检查',
    taskIsNotCompleted: '任务未完成',
  },
  popup_levelUp: {
    levelUp: '升级！',
    multiTap: '多重点击',
    energyLimit: '能量限制',
  },
  popup_BalanceUp: {
    balanceUp: '余额更新！',
    balanceDiffSinceLast: '您的奖励',
  },
  popup_BalanceTip: {
    tip: '提升您的收益',
    message: '点击"矿场"菜单为您的网络购买升级',
    description: '离线时最多可获得3小时的收益',
  },
  popup_Bored: {
    header: '青蛙感到无聊了！',
    message: '和青蛙玩耍。',
    description: '如果3小时内没有和青蛙玩耍，收益将停止',
  },
  popup_Hungry: {
    header: '青蛙饿了！',
    message: '给青蛙喂食。',
    description: '您拥有的朋友越多，每次喂食可以带来更多金币',
  },
  menu: {
    network: '网络',
    mine: '矿场',
    earn: '赚钱',
    food: '食物',
  },
  tap: {
    bored: '无聊',
    fun: '有趣',
  },
  mineMenu: {
    activities: '活动',
    investments: '投资',
    web3: 'WEB3',
    achievements: '成就',
  },
  leaderboard: {
    from: '来自',
    beTheFirst: '成为第一名！',
  },
  mine: {
    joinOurTG1: '加入我们的Telegram频道，',
    joinOurTG2: '解锁更多内容！',
    unlock: '解锁',
  },
  friends: {
    inviteFriends: '邀请好友！',
    receiveBonuses: '您和您的朋友都将获得奖励',
    inviteFriend: '邀请好友',
    withTelegramPremium: '使用Telegram Premium',
    forYouAndYourFriend: '为您和您的朋友',
    moreBonuses: '更多奖励',
    listOfYourFriends: '好友列表',
    linkCopied: '邀请链接已复制到剪贴板！',
    playWithMe:
      '加入我一起玩游戏，通过空投赚取代币！\n' +
      '💰 领取礼物！新用户可获得+3000金币\n' +
      '🚀 拥有Telegram Premium？获得+5000金币！\n',
  },
  earn: {
    moreCoins: '赚取更多金币！',
    dailyTasks: '每日任务',
    dailyReward: '每日奖励',
    tasksList: '任务列表',
    joinOurTG: '加入我们的Telegram频道',
    followOurX: '关注我们的X账号',
    yourAd: '这里可以是您的广告',
    connect: '联系我们Telegram频道的管理员',
  },
  food: {
    hungry: '饥饿',
    full: '已饱食',
    frogIsFull: '青蛙已吃饱',
    feed: '喂食',
    bonus: '奖励',
    satiety: '饱食度',
    hours: '小时',
  },
  toast: {
    buyCard: {
      title: '成就解锁！',
      subtitle: '是时候带领你的青蛙帝国走向伟大了 👑',
    },
    feedFrog: {
      title: '青蛙很开心！',
      subtitle: '干得好！继续喂养你的宠物以保持笑容 🍽️',
    },
  },
};
